import { render, staticRenderFns } from "./AppHeader.html?vue&type=template&id=b404a5f4&"
import script from "./AppHeader.js?vue&type=script&lang=js&"
export * from "./AppHeader.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports